/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import {cookies} from 'rest/helpers/cookies'
import type {ApiRequestOptions} from './ApiRequestOptions'

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>
type Headers = Record<string, string>

export type OpenAPIConfig = {
  BASE: string
  VERSION: string
  WITH_CREDENTIALS: boolean
  CREDENTIALS: 'include' | 'omit' | 'same-origin'
  TOKEN?: string | Resolver<string>
  USERNAME?: string | Resolver<string>
  PASSWORD?: string | Resolver<string>
  HEADERS?: Headers | Resolver<Headers>
  ENCODE_PATH?: (path: string) => string
}

export const OpenAPISMA: OpenAPIConfig = {
  BASE: String(process.env.REACT_APP_API_URL_SMA),
  VERSION: '1',
  WITH_CREDENTIALS: false,
  CREDENTIALS: 'include',
  TOKEN: undefined,
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: {
    'sma-site-key': process.env.REACT_APP_CLIENT_ID,
    'Is-Coupon-Center': '1',
  },
  ENCODE_PATH: undefined,
}

export const OpenAPICouponCenter: OpenAPIConfig = {
  BASE: String(process.env.REACT_APP_COUPON_CENTER_URL),
  VERSION: '1',
  WITH_CREDENTIALS: false,
  CREDENTIALS: 'include',
  TOKEN: cookies.get('access'),
  HEADERS: {
    'sma-site-key': process.env.REACT_APP_CLIENT_ID,
    'Is-Coupon-Center': '1',
  },
  USERNAME: undefined,
  PASSWORD: undefined,
  ENCODE_PATH: undefined,
}
